export default __webpack_public_path__ + "static/media/26-iris.5d96df0f.jpg";